import React from "react";
import { PeekSelect, PeekSelectOption } from "@piiqtechnologies/ui-components";
export const PageHeaderSelect = ({ reports }) => {
    if (!reports)
        return null;
    return (React.createElement(PeekSelect, { value: reports.value, onChange: (event) => reports.onChange(event.target.value), sx: {
            width: "fit-content",
            alignSelf: "end",
            background: "transparent",
            border: 0,
            "> button": {
                marginRight: 0,
                opacity: 1,
            },
            ".MuiSelect-select": {
                fontSize: "32px",
                fontWeight: "200",
            },
        } }, reports.options.map((option) => {
        return (React.createElement(PeekSelectOption, { key: option.value, value: option.value, disabled: option.disabled, hoverBgColor: "info", selectedBgColor: "info" }, option.label));
    })));
};
